import { normaliseString } from "@/lib/js"

/**
 * Generate a unique table row ID based on supplier account and name
 */
export function generateTableRowId(
	row: { name?: string | null; supplier_account?: string | null },
	suffix = "tablerow",
) {
	return `${suffix}-${row.supplier_account}-${normaliseString(
		row.name ?? "",
	)}`
}
